import { useBackend } from "../../services";

export const useGetMercadoPagoSubscriptionByEmail = () => {
  const { get } = useBackend();
  return async (props: { email: string }) => get("admin/subscription/mercadoPago", props);
};
